const emblaHomeBannerNode = document.querySelector('.embla.embla_home_banner');
const emblaHomeFeaturedNode = document.querySelector('.embla.embla_home_featured');
const emblaProductGalleryNode = document.querySelector('.embla.embla_product_gallery');

if (emblaHomeBannerNode != null) {
  const prevBtnHomeBannerNodes = document.querySelectorAll('.embla_home_banner_prev');
  const nextBtnHomeBannerNodes = document.querySelectorAll('.embla_home_banner_next');
  const optionsHomeBanner = { loop: true };
  const pluginsHomeBanner = [EmblaCarouselAutoplay({ delay: 4000 }), EmblaCarouselFade()];
  const emblaHomeBannerApi = EmblaCarousel(emblaHomeBannerNode, optionsHomeBanner, pluginsHomeBanner);
  const scrollPrev = () => {
    emblaHomeBannerApi.scrollPrev();
  };
  const scrollNext = () => {
    emblaHomeBannerApi.scrollNext();
  };
  prevBtnHomeBannerNodes.forEach((prevBtnHomeBannerNode) => {
    prevBtnHomeBannerNode.addEventListener('click', scrollPrev, false);
  });
  nextBtnHomeBannerNodes.forEach((nextBtnHomeBannerNode) => {
    nextBtnHomeBannerNode.addEventListener('click', scrollNext, false);
  });
  // console.log(emblaApi.slideNodes()); // Access API
}
if (emblaHomeFeaturedNode != null) {
  const prevBtnHomeFeaturedNode = document.querySelector('.embla_home_featured_prev');
  const nextBtnHomeFeaturedNode = document.querySelector('.embla_home_featured_next');
  const options = { loop: true };
  const emblaHomeFeaturedApi = EmblaCarousel(emblaHomeFeaturedNode, options);
  const scrollPrev = () => {
    emblaHomeFeaturedApi.scrollPrev();
  };
  const scrollNext = () => {
    emblaHomeFeaturedApi.scrollNext();
  };
  prevBtnHomeFeaturedNode.addEventListener('click', scrollPrev, false);
  nextBtnHomeFeaturedNode.addEventListener('click', scrollNext, false);
  // console.log(emblaApi.slideNodes()); // Access API
}
if (emblaProductGalleryNode != null) {
  const prevBtnProductGalleryNode = document.querySelector('.embla_product_gallery_prev');
  const nextBtnProductGalleryNode = document.querySelector('.embla_product_gallery_next');
  const dotsProductGalleryNode = document.querySelector('.embla_product_gallery_dots');
  const optionsProductGallery = { loop: true };
  const emblaProductGalleryApi = EmblaCarousel(emblaProductGalleryNode, optionsProductGallery);
  const scrollPrev = () => {
    emblaProductGalleryApi.scrollPrev();
  };
  const scrollNext = () => {
    emblaProductGalleryApi.scrollNext();
  };
  prevBtnProductGalleryNode.addEventListener('click', scrollPrev, false);
  nextBtnProductGalleryNode.addEventListener('click', scrollNext, false);

  const scrollTo = (index) => {
    emblaProductGalleryApi.scrollTo(index);
  };

  const dotProductGalleryNodes = Array.from(dotsProductGalleryNode.querySelectorAll('.embla_product_gallery_dot'));
  dotProductGalleryNodes.forEach((dotNode, index) => {
    dotNode.addEventListener(
      'click',
      (listener) => {
        dotProductGalleryNodes.forEach((dot, dotIndex) => {
          if (dotIndex == index) {
            dot.classList.add('active_dot');
          } else {
            dot.classList.remove('active_dot');
          }
        });
        scrollTo(index);
      },
      false,
    );
  });
}
const emblaProductGalleryGoto = (index) => {
  alert(index);
};
// Main menu -----------------------------------
const togglePartOne = (val) => {
  const xMmdOne = document.querySelector('#x_mmd_one');
  // if (xMmdOne.classList.contains('x_mmd_visible')) {
  if (!val) {
    xMmdOne.classList.remove('animate__fadeInLeft');
    xMmdOne.classList.add('animate__fadeOutLeft');
    setTimeout(() => {
      xMmdOne.classList.remove('x_mmd_one_visible');
    }, 500);
  }
  // } else {
  if (val == true) {
    xMmdOne.classList.remove('animate__fadeOutLeft');
    xMmdOne.classList.add('x_mmd_one_visible');
    xMmdOne.classList.add('animate__fadeInLeft');
  }
  // }
};
const togglePartTwo = (val) => {
  const xMmdTwo = document.querySelector('#x_mmd_two');
  // if (xMmdTwo.classList.contains('x_mmd_visible')) {
  if (!val) {
    xMmdTwo.classList.remove('animate__fadeInLeft');
    xMmdTwo.classList.add('animate__fadeOutLeft');
    setTimeout(() => {
      xMmdTwo.classList.remove('x_mmd_two_visible');
    }, 500);
  }
  // } else {
  if (val == true) {
    xMmdTwo.classList.remove('animate__fadeOutLeft');
    xMmdTwo.classList.add('x_mmd_two_visible');
    xMmdTwo.classList.add('animate__fadeInLeft');
  }
  // }
};
const togglePartThree = (val) => {
  const xMmdThree = document.querySelector('#x_mmd_three');
  // if (xMmdThree.classList.contains('x_mmd_visible')) {
  if (!val) {
    xMmdThree.classList.remove('animate__fadeInLeft');
    xMmdThree.classList.add('animate__fadeOutLeft');
    setTimeout(() => {
      xMmdThree.classList.remove('x_mmd_three_visible');
    }, 500);
  }
  // } else {
  if (val == true) {
    xMmdThree.classList.remove('animate__fadeOutLeft');
    xMmdThree.classList.add('x_mmd_three_visible');
    xMmdThree.classList.add('animate__fadeInLeft');
  }
  // }
};
const toggleMainMenu = () => {
  const xMmd = document.querySelector('#mainMenuDrawer');
  if (xMmd.classList.contains('x_mmd_visible')) {
    togglePartThree(false);
    togglePartTwo(false);
    togglePartOne(false);
    xMmd.classList.remove('animate__fadeIn');
    xMmd.classList.add('animate__fadeOut');
    setTimeout(() => {
      xMmd.classList.remove('x_mmd_visible');
    }, 500);
  } else {
    xMmd.classList.remove('animate__fadeOut');
    xMmd.classList.add('x_mmd_visible');
    xMmd.classList.add('animate__fadeIn');
    togglePartOne(true);
  }
};
const showPartTwoMainMenu = (val) => {
  // alert(val);
  const xMmdTwoSections = document.querySelectorAll('.x_mmd_two__section');
  const xMmdThreeSections = document.querySelectorAll('.x_mmd_three__section');
  // console.log(xMmdTwoSections);
  if (xMmdTwoSections.length > 0) {
    for (const section of xMmdTwoSections) {
      // console.log(section.id);
      if (section.id == 'x_mmd_two_' + val) {
        section.classList.remove('x_mmd_two__section_invisible');
        togglePartTwo(true);
      } else {
        section.classList.add('x_mmd_two__section_invisible');
      }
    }
  }
  if (xMmdThreeSections.length > 0) {
    for (const section of xMmdThreeSections) {
      // console.log(section.id);
      if (section.id == 'x_mmd_three_' + val) {
        section.classList.remove('x_mmd_three__section_invisible');
        togglePartThree(true);
      } else {
        section.classList.add('x_mmd_three__section_invisible');
      }
    }
  }
};
// Main menu -----------------------------------

// Custom product size -------------------------
function toggleCustomSizeOptions() {
  const customSizeToggleBtn = document.querySelector('#customSizeOptions');
  const customSizeToggleBtnText = document.querySelector('#customSizeToggleText');
  if (customSizeToggleBtn.classList.contains('block_visible')) {
    customSizeToggleBtn.classList.remove('animate__fadeIn');
    customSizeToggleBtn.classList.add('animate__fadeOut');
    setTimeout(() => {
      customSizeToggleBtn.classList.remove('block_visible');
      customSizeToggleBtnText.textContent = 'Customize Size';
    }, 500);
  } else {
    customSizeToggleBtn.classList.remove('animate__fadeOut');
    customSizeToggleBtn.classList.add('block_visible');
    customSizeToggleBtnText.textContent = 'Hide Custom Sizes';
    customSizeToggleBtn.classList.add('animate__fadeIn');
  }
}
// Custom product size -------------------------
